import { errorToast } from "@/v2-ui/toast"
import Selector from "@/v2-backoffice-client/components/selector"
import type { SelectorItemProps } from "@/v2-backoffice-client/components/selector"
import type { CustomerFragment } from "@/v2-backoffice-client/customer/__types__/customer.fragment"
import { useTenantCustomerAddManyMutation } from "@/v2-backoffice-client/tenant/customer/add/many/tenant.customer.add.many.mutation"

export type TenantCustomerAddManySelectorItemProps = Omit<
  SelectorItemProps,
  "value" | "children" | "onSelect"
> & {
  customer: CustomerFragment
  tenantIds: number[]
  onSelect?(): void
}

function TenantCustomerAddManySelectorItem(
  props: TenantCustomerAddManySelectorItemProps,
) {
  const { customer, tenantIds, onSelect, ...selectorItemProps } = props

  const [assignMany, { loading, error }] = useTenantCustomerAddManyMutation()
  errorToast(error, {
    title: "Failed to assign teams to customer",
  })

  return (
    <Selector.Item
      isLoading={loading}
      value={`${customer.Name ?? ""} ${customer.ExternalCustomerId ?? ""}`}
      onSelect={() => {
        // Tenant assignment still keys on the legacy HubSpot id; an
        // app-created customer must be linked to a company first.
        if (!customer.ExternalCustomerId) return
        assignMany({
          variables: {
            tenantIds,
            externalCustomerId: customer.ExternalCustomerId,
          },
        })
        onSelect?.()
      }}
      {...selectorItemProps}
    >
      <Selector.ItemText
        primary={customer.Name ?? "Unnamed"}
        secondary={
          customer.ExternalCustomerId ??
          "Not linked to HubSpot — link a company before assigning"
        }
      />
    </Selector.Item>
  )
}

export default TenantCustomerAddManySelectorItem
